import { render, staticRenderFns } from "./BindEmailForm.vue?vue&type=template&id=6c9b7e30&"
import script from "./BindEmailForm.vue?vue&type=script&lang=js&"
export * from "./BindEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports